#import "../fragments/template-stub-fragment.graphql"

query GetTemplates(
    $archived: Boolean!
    $sort: BroadcastSortType!
    $search: String
    $statuses: [CampaignStatus!]
) {
    templates(archived: $archived, sort: $sort, search: $search, statuses: $statuses) {
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            cursor
            node {
                ...TemplateStubFragment
            }
        }
    }
}
